import { http_build_query } from "/src/lib/http/index.js";

// https://newproperties.sg/wp-json/wp/v2/project?_fields[]=sync_id&_fields[]=launch_date&_fields[]=date&per_page=300&orderby_custom[0]=launch_date&orderby_isnull_custom[0]=1&order_custom[0]=DESC&ordertype_custom[0]=DATE&orderby_custom[1]=post_date&order_custom[1]=DESC&ordertype_custom[1]=date&orderby_custom[2]=launch_date&order_custom[2]=DESC&ordertype_custom[2]=DATE

async function wordpressPostTypeList({ url, fields, filter, order, page=1, per_page=100, max_page=5, ...otherParams }) {

  let full_url = `${url}?`;
  if (fields) {
    full_url += http_build_query({ _fields: fields });
  }
  if (filter) {
    full_url += "&"+http_build_query({ filter: filter, ...otherParams });
  }
  if (order) {
    const { orderby_custom, orderby_isnull_custom, order_custom, ordertype_custom } = order;
    full_url += "&"+http_build_query({ orderby_custom, orderby_isnull_custom, order_custom, ordertype_custom });
  }

  // full_url += "&_wpnonce=1f469416d5";

  // ?per_page = 1 to 100
  // ?per_page=5&page=4 is equivalent to ?per_page=5&offset=1
  let totalPages = page, total = 0, totalData = [];

  for (let i=page; i<=Math.min(max_page, totalPages); i++) {
    //
    console.log(`Searching Page ${i}...`);
    var t0 = performance.now();
    //
    const pagingParams = new URLSearchParams({ page: i, per_page });
    const res = await fetch(`${full_url}&${pagingParams.toString()}`, {
        method: "GET",
        headers: {
          "Accept": "application/json",
        }
      }
    );
    const headers = res.headers;
    const data = await res.json();
    if (headers.get('x-wp-total')) {
      const x_wp_total = parseInt(headers.get('x-wp-total'));
      total = x_wp_total;
    }
    if (headers.get('x-wp-totalpages')) {
      const x_wp_totalpages = parseInt(headers.get('x-wp-totalpages'));
      totalPages = x_wp_totalpages || totalPages;
    }
    if (Array.isArray(data)) {
      totalData.push(...data);
    }
    //
    var t1 = performance.now();
    var elapsed = (t1 - t0);
    console.log(`Done: Got ${data.length} in ${elapsed}`);
    //
  }
  return {
    total,
    totalPages,
    data: totalData,
  };

}

export {
  wordpressPostTypeList
}
